<template>
  <vue-final-modal
    :name="name"
    @before-close="$emit('before-close')"
    @closed="$emit('after-close')"
    v-model="showModal"
    :classes="classes"
    :overlay-class="overlayClass"
    :content-class="contentClass"
    :esc-to-close="true"
    :click-to-close="clickToClose"
  >
    <slot v-bind="{ closeModal }"></slot>
  </vue-final-modal>
</template>

<script>
import { ref } from 'vue'

export default {
  emits: ['before-close', 'after-close'],
  props: {
    name: { type: String, default: null },
    classes: { type: [String, Object, Array], default: '' },
    overlayClass: { type: [String, Object, Array], default: '' },
    contentClass: { type: [String, Object, Array], default: '' },
    clickToClose: { type: Boolean, default: true },
    defaultOpen: { type: Boolean, default: false },
  },
  setup(props) {
    const showModal = ref(props.defaultOpen)
    const closeModal = () => {
      showModal.value = false
    }

    return {
      showModal,
      closeModal,
    }
  },
}
</script>
